export const STOREFRONT = {
  url: process.env.NEXT_PUBLIC_STOREFRONT_API_URL,
  token: process.env.NEXT_PUBLIC_STOREFRONT_API_TOKEN
};

export const GRAPHQL = {
  url: process.env.NEXT_PUBLIC_GRAPHQL_API_URL,
  allowGraphQLPages: JSON.parse(process.env.ALLOW_GRAPHQL_PAGES || false)
};

export const PLATFORM = {
  url: process.env.NEXT_PUBLIC_PLATFORM_API_URL
};

export const CLIENT = {
  url: process.env.NEXT_PUBLIC_SHOPIFY_URL
};

export const GTM = {
  id: process.env.NEXT_PUBLIC_GTM_ID,
  previewEnv: process.env.NEXT_PUBLIC_GTM_PREVIEW_ENV,
  auth: process.env.NEXT_PUBLIC_GTM_AUTH
};

export const ENVIRONMENT = process.env.NEXT_PUBLIC_ENV;

export const DOMAIN =
  process.env.NEXT_PUBLIC_DOMAIN || 'https://shop.bombas.com';

export const ONETRUST = {
  id: process.env.ONE_TRUST_ID
};

export const UPSELL_COLLECTION_ID =
  process.env.NEXT_PUBLIC_UPSELL_COLLECTION_ID;

export const YOTTAA = {
  key: process.env.NEXT_PUBLIC_YOTTAA_KEY
};

export const OPTIMIZELY_ID = process.env.NEXT_PUBLIC_OPTIMIZELY_FULL_STACK;

export const ATTENTIVE_SMS_MOBILE_UNIT =
  process.env.NEXT_PUBLIC_ATTENTIVE_SMS_MOBILE_UNIT;

export const ATTENTIVE_SMS_DESKTOP_UNIT =
  process.env.NEXT_PUBLIC_ATTENTIVE_SMS_DESKTOP_UNIT;

export const NOT_FOUND_PAGE = {
  id: process.env.NOT_FOUND_PAGE_ID
};

export const TECHNICAL_ERROR_PAGE = {
  id: process.env.TECHNICAL_ERROR_PAGE_ID
};

export const MENS_COLLECTION = {
  id: process.env.MENS_COLLECTION_ID
};

export const GOOGLE = {
  mapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY
};

export const YOTPO = {
  key: process.env.NEXT_PUBLIC_YOTPO_KEY,
  review_widget: process.env.NEXT_PUBLIC_YOTPO_REVIEW_WIDGET,
  seo_widget: process.env.NEXT_PUBLIC_YOTPO_SEO_WIDGET,
  star_widget: process.env.NEXT_PUBLIC_YOTPO_STAR_WIDGET
};

export const GLOBAL_E = {
  merchant_id: process.env.NEXT_PUBLIC_GLOBAL_E_MERCHANT_ID,
  env: process.env.NEXT_PUBLIC_GLOBAL_E_ENV
};

export const REDIRECT_SHOPIFY_URL =
  process.env.NEXT_PUBLIC_REDIRECT_SHOPIFY_URL;

export const CROSS_BORDER_ENABLED =
  process.env.NEXT_PUBLIC_CROSS_BORDER_ENABLED === 'true';

export const REBUY_API_KEY = process.env.NEXT_PUBLIC_REBUY_API_KEY;
export const REBUY_CART_UPSELL_ID =
  process.env.NEXT_PUBLIC_REBUY_CART_UPSELL_ID;
export const REBUY_PDP_UPSELL_IDS =
  process.env.NEXT_PUBLIC_REBUY_PDP_UPSELL_IDS;

export const PRODUCT_CARD_SAVINGS_VARIATION =
  process.env.NEXT_PUBLIC_PRODUCT_CARD_SAVINGS_COPY_VARIATION;
